// extracted by mini-css-extract-plugin
export default {"wrapper":"DocsButton_wrapper__8mtu-","imageContainer":"DocsButton_imageContainer__J-K4y","image":"DocsButton_image__ZlUQp","text":"DocsButton_text__jYO1m"};